module.exports = __webpack_public_path__ + "fonts/lato-v11-latin-regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/js/core/fonts/lato-v11-latin-regular.ttf
// module id = 19
// module chunks = 0